export const startReqActionType = str => str + '_REQUEST';
export const failReqActionType = str => str + '_FAILURE';
export const successReqActionType = str => str + '_SUCCESS';
